import { TaskBase } from "@calaosoft/osapp-mobile/modules/bts/models/task-base";
import { TaskDescriptor } from "@calaosoft/osapp-mobile/modules/bts/models/task-descriptor";
import { ECatalogVersionResponseStatus } from "@calaosoft/osapp-mobile/modules/logistics/catalog/models/ECatalogVersionResponseStatus";
import { ICatalogVersionResponse } from "@calaosoft/osapp-mobile/modules/logistics/catalog/models/ICatalogVersionResponse";
import { CatalogService } from "@calaosoft/osapp-mobile/modules/logistics/catalog/services/catalog.service";
import { defer, EMPTY, Observable } from "rxjs";
import { catchError, last, map, mergeMap } from "rxjs/operators";
import { IArticleCatalogUpdateTaskParams } from "./IArticleCatalogUpdateTaskParams";

/** Compare le dernier catalogue téléchargé avec celui sur le serveur, le télécharge et l'installe s'il y a une mise à jour. */
export class ArticleCatalogUpdateTask<T extends IArticleCatalogUpdateTaskParams> extends TaskBase<T> {
	//#region FIELDS

	private static readonly C_LOG_ID = "CTLG.UPDATETASK::";

	private readonly msvcCatalogService: CatalogService;

	//#endregion

	//#region METHODS

	constructor(poDescriptor: TaskDescriptor<T>) {
		super(poDescriptor);

		this.msvcCatalogService = poDescriptor.ioInjector.get(CatalogService);
	}

	protected override execTask$(): Observable<void> {
		return this.msvcCatalogService.getLastVersionData().pipe(
			mergeMap((poCatalogResponse: ICatalogVersionResponse) => {
				if (poCatalogResponse.status === ECatalogVersionResponseStatus.available) {
					return defer(() => this.msvcCatalogService.isUpToDateAsync(poCatalogResponse)).pipe(
						mergeMap((pbIsUpToDate: boolean) => this.donwloadAndInstallIfNeeded$(poCatalogResponse, pbIsUpToDate))
					);
				} else return EMPTY;
			}),
			catchError((poError) => {
				console.error(`${ArticleCatalogUpdateTask.C_LOG_ID}Error when updating catalog:`, poError);
				return EMPTY;
			})
		);
	}

	private donwloadAndInstallIfNeeded$(
		poCatalogResponse: ICatalogVersionResponse,
		pbIsUpToDate: boolean
	): Observable<void> {
		if (pbIsUpToDate) return EMPTY;
		else {
			return this.msvcCatalogService.downloadAndInstall$(poCatalogResponse).pipe(
				last(),
				map((_) => undefined)
			);
		}
	}

	//#endregion
}
